<div
  class="user-avatar-container"
  [class.with-name]="showName"
  [class.clickable]="clickable"
  [class.avatar-after]="avatarAfterName"
>
  <div
    class="avatar-wrapper"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="onAvatarClick()"
  >
    @if (!avatarAfterName) {
      <span
        class="user-avatar"
        [class.small]="size === 'small'"
        [class.large]="size === 'large'"
        [innerHtml]="'<i class=\'' + iconClass + '\'>'"
      ></span>
    }

    @if (showName) {
      <span
        class="user-name"
        [class.small]="size === 'small'"
        [class.large]="size === 'large'"
      >
        {{ displayName }}
      </span>
    }

    @if (avatarAfterName) {
      <span
        class="user-avatar"
        [class.small]="size === 'small'"
        [class.large]="size === 'large'"
        [innerHtml]="'<i class=\'' + iconClass + '\'>'"
      ></span>
    }
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="dropdownOpen && clickable"
  [cdkConnectedOverlayPositions]="overlayPositions"
>
  <div
    class="user-dropdown"
    (click)="$event.stopPropagation()"
  >
    <div class="dropdown-header">
      <div class="user-full-name">{{ fullName }}</div>
      @if (user?.Username && user?.Username !== fullName) {
        <div class="user-username">{{ '@' + user.Username }}</div>
      }
      @if (showMotiLabel) {
        <div
          class="user-username"
          [innerText]="'@moti'"
        ></div>
      }
      @if (user?.Email && user?.Email !== fullName) {
        <div class="user-email">{{ user.Email }}</div>
      }
    </div>
  </div>
</ng-template>
